/* global reserve_shoe_ajax_url */
/* global ajax_nonce */
/* global multi_add_to_cart_ajax_url */

import PhotoSwipeLightbox from 'photoswipe/lightbox';

export default {
  init() {
    greyOutOfStock();
    getVariationId();
    changeColorLabel();
    checkIfVariantIsOnBackorder();
    productInformationFlapOut();
    scrollToReviewBlock();
    addBulkVariationToCart();
    moveHelloRetailRecommendations();
    initializeModalReserve();
    // loadSizeFromLocalStorage();
    initializeModalSizeSelection();
    initializeModalShoeSize();
    handleTrustedShopsWidget();

    $('.reserve-input').on('input', function () {
      reserveValidation();
    });

    $('.wolkyshop_sizes_dropdown').wsSizeSelection();

    const mobileQuery = window.matchMedia('(max-width: 767px)');

    const handleLayoutChange = (e) => {
      if (e.matches) {
        this.destroyDesktopGallery();
        this.initMobileSlick();
      } else {
        this.destroyMobileSlick();
        this.initDesktopGallery();
      }
    };

    mobileQuery.addEventListener('change', handleLayoutChange);
    handleLayoutChange(mobileQuery);
  },

  initMobileSlick() {
    let wrapper = $('.product-detail-image-wrapper .wrapper');
    let sliderDiv = $('.ws-product-detail-image-slider');
    if (sliderDiv.hasClass('slick-initialized')) return;

    let images = wrapper.find('img');
    let imagesLoaded = 0;

    const imagesDoneLoading = () => {
      sliderDiv.slick({
        waitForAnimate: false,
        infinite: true,
        speed: 300,
        arrows: true,
        dots: true,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 1,
        variableWidth: false,
        prevArrow: '<div class="slick-prev"><div class="left-button"><i><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg></i></div></div>',
        nextArrow: '<div class="slick-next"><div class="right-button"><i><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/></svg></i></div></div>',
      });

      if (!this.pswpMobile) {
        this.pswpMobile = new PhotoSwipeLightbox({
          gallery: '.ws-product-detail-image-slider',
          children: '.slick-slide:not(.slick-cloned) .wolky-img',
          pswpModule: () => import('photoswipe'),
        });
        this.pswpMobile.init();
      }

      sliderDiv.find('video').each(function () {
        this.setAttribute('playsinline', '');
        this.setAttribute('autoplay', '');
      });

      sliderDiv.on('click', '.wolky-video', function(e) {
        e.stopPropagation();
      });

      sliderDiv.on('beforeChange', function() {
        sliderDiv.find('video').each(function () { this.pause(); });
      });

      sliderDiv.on('afterChange', function(event, slick, currentSlide){
        let video = $(slick.$slides[currentSlide]).find('video');
        if (video.length) video[0].play();
      });

      wrapper.addClass('slick-actually-initialized');
    };

    if (images.length === 0) {
      imagesDoneLoading();
    } else {
      images.each(function (index, elem) {
        let img = new Image();
        img.onload = () => {
          imagesLoaded++;
          if (imagesLoaded >= images.length) imagesDoneLoading();
        };
        img.src = elem.src;
      });
    }
  },

  destroyMobileSlick() {
    const $slider = $('.ws-product-detail-image-slider');
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
    if (this.pswpMobile) {
      this.pswpMobile.destroy();
      this.pswpMobile = null;
    }
  },

  initDesktopGallery() {
    if (!this.pswpLightbox) {
      this.pswpLightbox = new PhotoSwipeLightbox({
        gallery: '.ws-product-detail-image-slider',
        children: '.wolky-img',
        pswpModule: () => import('photoswipe'),
      });
      this.pswpLightbox.init();
    }

    $('.summary.entry-summary').wsSmartSticky({
      minWidth: 767,
      'paddingTop': '2rem',
      onlyScrollPadding: false,
    });

    $('.ws-product-detail-image-navigation').wsSmartSticky({
      minWidth: 767,
      'paddingTop': '2rem',
      onlyScrollPadding: true,
    });

    this.setupDesktopScrollNav();
  },

  setupDesktopScrollNav() {
    const $sliderImages = $('.ws-product-detail-image-slider .wolky-img, .ws-product-detail-image-slider .wolky-video-container');
    const $navItems = $('.ws-product-detail-image-navigation .wolky-img, .ws-product-detail-image-navigation .wolky-video');
    const $header = $('header.header');
    const baseFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    const scrollOffsetPadding = 1.6 * baseFontSize;

    $navItems.on('click.wsDesktop', function(e) {
      e.preventDefault();
      const index = $(this).index();
      const $targetImage = $sliderImages.eq(index);
      const headerOffset = $header.find('.top').outerHeight() + $header.find('.bottom').outerHeight();

      $('html, body').stop().animate({
        scrollTop: $targetImage.offset().top - headerOffset - scrollOffsetPadding,
      }, 500);
    });

    const updateActiveNav = () => {
      const scrollTop = $(window).scrollTop() + 250;
      let activeIndex = 0;
      $sliderImages.each(function(i) {
        if ($(this).offset().top < scrollTop) activeIndex = i;
      });
      $navItems.removeClass('active').eq(activeIndex).addClass('active');
    };

    $(window).on('scroll.wsDesktop', updateActiveNav);
    updateActiveNav();
  },

  destroyDesktopGallery() {
    $(window).off('.wsDesktop');
    $('.ws-product-detail-image-navigation .wolky-img').off('.wsDesktop');
    if (this.pswpLightbox) {
      this.pswpLightbox.destroy();
      this.pswpLightbox = null;
    }
  },

  finalize() {},
};

export var reserveValidation = () => {
  var reserveFirstName = $('#reserve-firstname').val();
  var reserveLastName = $('#reserve-lastname').val();
  var reservePhoneNumber = $('#reserve-phonenumber').val();
  var reserveEmail = $('#reserve-email').val();
  var reserveStreet = $('#reserve-street').val();
  var reserveHouseNumber = $('#reserve-housenumber').val();
  var reservePostalCode = $('#reserve-postalcode').val();
  var reserveCity = $('#reserve-city').val();

  if (reserveFirstName != '' && reserveLastName != '' && reservePhoneNumber != '' && reserveEmail != ''
    && reserveStreet != '' && reserveHouseNumber != '' && reservePostalCode != '' && reserveCity != '') {
    $('#reserve-submit').prop('disabled', false);
  } else {
    $('#reserve-submit').prop('disabled', true);
  }
}

export var changeColorLabel = () => {
  $('.variant-color').hover(function () {
    $('.selected_color').text($(this).attr('data-product'));
  }, function () {
    $('.selected_color').text($('.selected_color').attr('data-initial-color'));
  });
}

export var checkSizeIsInStock = (size) => {
  let is_in_stock = false;
  let variations = $('form.variations_form').data('product_variations');
  $(variations).each(function () {
    if (this.attributes.attribute_pa_size == size) {
      is_in_stock = this.is_in_stock;
      return false;
    }
  });
  return is_in_stock;
}

export var checkSizeExists = (size) => {
  let size_exists = false;
  let variations = $('form.variations_form').data('product_variations');
  $(variations).each(function () {
    if (this.attributes.attribute_pa_size == size) {
      size_exists = true;
      return false;
    }
  });
  return size_exists;
}

export var checkIfVariantIsOnBackorder = () => {
  $(function($) {
    $('.variations_form').on('found_variation', function(event, variation) {
      if (variation.back_order_date && variation.back_order_date.trim() !== '') {
        $('.product-delivery-time').css('display', 'flex');
      } else {
        $('.product-delivery-time').hide();
      }
    });

    $('.variations_form').on('reset_data', function() {
      $('.product-delivery-time').hide();
    });
  });
}

export var loadSizeFromLocalStorage = () => {
  const menucheck = document.querySelector('#menu-hoofdmenu > .current-menu-ancestor > a');
  if (menucheck) {
    const checker = menucheck.dataset.wsTitle;
    let size = '';

    if (document.body.classList.contains('logged-in') && document.getElementById('size_is_set')) {
      size = document.getElementById('size_is_set').innerText;
    } else if (localStorage.getItem('size')) {
      size = localStorage.getItem('size');
    }

    if (size) {
      let gender = localStorage.getItem('gender');
      let is_in_stock = checkSizeIsInStock(size);

      if (is_in_stock) {
        $('.wolkyshop_sizes_dropdown').val(size).trigger('change');
      } else if (checkSizeExists(size) && checker === gender) {
        $('#sold_out_pa_size').css('display', 'inline-block');
        $('<span class="selected_size">' + size.replace('-', '.') + '</span>').appendTo('#pa_size_label');
      }
    }
  }
}

export var handleTrustedShopsWidget = () => {
  const widgets = document.querySelectorAll('etrusted-widget');

  widgets.forEach((widget) => {
    const reviewBlock = widget.closest('.review-block');
    const contentBlock = widget.closest('.retractable-block-content');

    if (!reviewBlock || !contentBlock) return;

    contentBlock.style.display = 'block';
    contentBlock.style.visibility = 'hidden';
    contentBlock.style.height = '1px';
    contentBlock.style.overflow = 'hidden';

    let attempts = 0;

    const checkInterval = window.setInterval(() => {
      attempts++;

      const widgetHeight = widget.getBoundingClientRect().height || widget.offsetHeight;

      if (widgetHeight > 40) {
        window.clearInterval(checkInterval);

        contentBlock.style.display = '';
        contentBlock.style.visibility = '';
        contentBlock.style.height = '';
        contentBlock.style.overflow = '';

        reviewBlock.style.display = 'block';
      }

      if (attempts >= 8) {
        window.clearInterval(checkInterval);
        reviewBlock.style.display = 'none';
      }
    }, 500);
  });
};

export var getVariationId = () => {
  let elVariationId = $('.variation_id');
  elVariationId.change(function () {
    let val = elVariationId.val();
    $('.ajax_add_to_cart').each(function () {
      this.dataset.product_id = val;
    });

    if (val) {
      $('.reserve_button').prop('disabled', false);
      $('.wolky-shops').prop('disabled', false);
      $('.choose-size-option').remove();
      $('.choose-location-option').prop('selected', true);
    } else {
      $('.wolky-shops').prop('disabled', true);
      $('.reserve_button').prop('disabled', true);
    }
  });
}

export var greyOutOfStock = () => {
  $('.wolkyshop_sizes_dropdown').change(function () {
    const colors = $('.color-image');
    let selectedSize = $('select[name="attribute_pa_size"]').val();

    if (selectedSize) {
      const formattedSize = selectedSize.replace('-', '.');

      colors.each(function () {
        const $this = $(this);
        const isUnavailable = !$this.hasClass(formattedSize);

        if (isUnavailable) {
          $this.addClass('disabled');
        } else {
          $this.removeClass('disabled');
        }
      });
    } else {
      colors.removeClass('disabled');
    }
  });
}

export var initializeModalSizeSelection = () => {
  $('.variations_form').on('click', '.single_add_to_cart_button', function (event) {

    if ($('input[name=add-variations-to-cart]').val() === 'true') {
      return;
    }

    const $form = $(this).closest('.variations_form');
    const $sizeSelect = $form.find('#pa_size');
    const $sizeOptions = $form.find('.ws-size-selection-option');
    const $errorMsg = $('.woocommerce-variation-select-size-error');

    if ($sizeSelect.val() === '' || $sizeSelect.val() === undefined) {
      event.preventDefault();
      event.stopImmediatePropagation();

      $sizeOptions.addClass('has-error');
      $errorMsg.show();

      return false;
    }
  });

  $(document).on('click', '.ws-size-selection-option', function() {
    $('.ws-size-selection-option').removeClass('has-error');
    $('.woocommerce-variation-select-size-error').hide();
  });

  $('.show-more-colors, .show-less-colors').on('click', function() {
    const $wrapper = $(this).closest('.wolkyshop-color-selection');
    const $container = $wrapper.find('.color-container');

    $container.toggleClass('is-open');
    $wrapper.find('.show-more-colors, .show-less-colors').toggle();
  });
}

export var initializeModalReserve = () => {
  let modalReserve = $('#ws-modal-reserve').wsModal();
  let currentStep = 1;
  let loading = false;

  const updateStepVisibility = () => {
    $('.modal-step').hide();
    $(`.modal-step[data-step="${currentStep}"]`).show();

    $('.steps-navigation').hide();
  };

  $(document).on('click', '.back', function() {
    if (currentStep > 1) {
      currentStep--;
      updateStepVisibility();
    }
  });

  $(document).on('click', '.size-selection .ws-size-selection-option:not(.disabled)', function() {
    const selectedSize = $(this).text().trim();

    $('.js-selected-size-display').text(selectedSize);
    $('.ws-size-selection-option').removeClass('selected');
    $(this).addClass('selected');

    $('.variation-content .ws-size-selection-option').filter(function() {
      return $(this).text().trim() === selectedSize;
    }).trigger('click');

    setTimeout(() => {
      let variationId = $('.single_add_to_cart_button').attr('data-product_id');

      if (!variationId || variationId === '') {
        variationId = $('input[name="variation_id"]').val();
      }

      $('#reserve-product-id').val(variationId);

      currentStep = 2;
      updateStepVisibility();
    }, 150);
  });

  $(document).on('click', 'input[name="selected_store"]', function() {
    const storeName = $(this).closest('.store-option').find('.store-name').text();
    const storeId = $(this).val();

    $('.shoe-store-reservation-name, .reserve-success-shop').text(storeName);
    $('#store-location-hidden').val(storeId);

    setTimeout(() => {
      currentStep = 3;
      updateStepVisibility();
    }, 250);
  });

  $('.reserve-shoe').on('click', function () {
    currentStep = 1;
    updateStepVisibility();

    $('.size-selection').empty();
    $('.variation-content').find('.ws-size-selection').clone().appendTo('.size-selection');

    modalReserve.wsModal('open');
  });

  $('#reserve_form').on('submit', function (e) {
    e.preventDefault();
    if (loading) return;

    loading = true;
    modalReserve.wsModal('setLoading', true);

    let form_data = $(this).serializeArray();
    form_data.push({'name': 'security', 'value': ajax_nonce});
    form_data.push({'name': 'action', 'value': 'reserve_shoe'});

    $.ajax({
      url: reserve_shoe_ajax_url.ajax_url,
      type: 'post',
      data: form_data,
      success: function (response) {
        loading = false;
        modalReserve.wsModal('setLoading', false);
        if (response.status === 'success') {
          currentStep = 4;
          updateStepVisibility();
        } else {
          console.log(response);
          alert('Er ging iets mis, probeer het opnieuw.');
        }
      },
    });
  });
}

export var initializeModalShoeSize = () => {
  let sizeModal = $('#shoe-size-modal').wsModal();
  $('#size-chart-button').click(() => sizeModal.wsModal('open'));
}

export var slideOnKeyPress = () => {
  window.addEventListener('keydown', function (event) {
    let slider = $('body').hasClass('ws-modal-open') ? $('.ws-product-detail-image-lightbox-slider') : $('.ws-product-detail-image-slider');
    if (event.defaultPrevented || !slider.hasClass('slick-initialized')) return;

    switch (event.key) {
      case 'ArrowLeft': slider.slick('slickPrev', true); break;
      case 'ArrowRight': slider.slick('slickNext', true); break;
      default: return;
    }
    event.preventDefault();
  }, true);
}

export var productInformationFlapOut = () => {

  let retractableBlock = $('.retractable-block');

  nonRetractableDesktopBlock($(window).width());

  $(window).resize(function() {
    let pageWidth = $(window).width();
    nonRetractableDesktopBlock(pageWidth);
  });

  function nonRetractableDesktopBlock(pageWidth) {
    $('.non-retractable-desktop').each(function () {
      let title = $(this).find($('.retractable-block-title'));
      let content = $(this).find($('.retractable-block-content'));
      let up = title.find('.up');
      let down = title.find('.down');

      if (pageWidth >= 1024 || $(this).hasClass('non-retractable-mobile')) {
        content.show();
        down.hide();

        if($(this).hasClass('non-retractable-mobile')) {
          up.show();
        } else {
          up.hide();
        }
      }else {
        content.hide();
        up.hide();
        down.show();
      }
    });
  }

  retractableBlock.find('.retractable-block-title').click(function () {
    if (!$(this).parent().hasClass('non-retractable-desktop')) {
      show_hide($(this));
    }

    if ($(this).parent().hasClass('non-retractable-desktop') && $(window).width() < 1024) {
      show_hide($(this));
    }
  });

  function show_hide(element) {
    let up = element.find('.up')
    let down = element.find('.down');
    let content = $('.retractable-block-content');
    if (element.next(content).is(':hidden')) {
      element.next(content).slideDown(500);
      up.show();
      down.hide();
    } else {
      element.next(content).slideUp(500);
      up.hide();
      down.show();
    }
  }
}

export var scrollToReviewBlock = () => {
  $('.product-rating').off('click').on('click', function(e) {
    e.preventDefault();

    const $reviewBlock = $('.review-block');
    if (!$reviewBlock.length) return;

    const $title = $reviewBlock.find('.retractable-block-title');
    const $content = $reviewBlock.find('.retractable-block-content');

    if ($content.is(':hidden')) {
      $title.trigger('click');
    }

    $('html, body').stop().animate({
      scrollTop: $reviewBlock.offset().top - 100,
    }, 800);
  });
}

export var addBulkVariationToCart = () => {
  if ($('input[name=add-variations-to-cart]').val() !== 'true') {
    return;
  }

  const qtyInputs = $('.qty_input');
  const qtyTotal = $('.wolkyQuantityTotal');
  const addToCartButton = $('.single_add_to_cart_button');

  addToCartButton.on('click', function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    let productsData = [];

    qtyInputs.each(function() {
      if($(this).val() > 0) {
        let variationProductId = $(this).attr('data-variation-id');
        let productId = $(this).attr('data-product-id');
        productsData.push({
          'product_id': productId,
          'variation_product_id': variationProductId,
          'qty': $(this).val(),
        });
      }
    });

    if(productsData.length > 0) {
      addToCartButton.addClass('loading');

      $.ajax({
        url: multi_add_to_cart_ajax_url.ajax_url,
        type: 'post',
        dataType: 'json',
        data: {
          'items' : Object.assign({}, productsData),
        },
        success : function(response) {
          if ( ! response ) {
            return;
          }
          $( document.body ).trigger( 'added_to_cart', [ response.fragments, response.cart_hash ] );
        },
        complete: function() {
          addToCartButton.removeClass('loading');
        },
      });
    }
  });

  qtyInputs.keyup(function () {
    $('.single_variation_wrap').find('.single_add_to_cart_button').removeClass('disabled wc-variation-selection-needed');
  });

  const calculateAndValidateTotal = function() {
    let total = 0;
    qtyInputs.each(function () {
      const el = $(this);
      const max = parseInt(el.attr('max'));
      let val = parseInt(el.val());

      if (val > max) {
        val = max;
      }
      if (val < 0) {
        val = 0;
      }

      el.val(val);
      total += val;
    });

    qtyTotal.html(total);

    if (total > 0) {
      addToCartButton.removeAttr('disabled').removeClass('disabled wc-variation-selection-needed');
    } else {
      addToCartButton.attr('disabled', true).addClass('disabled wc-variation-selection-needed');
    }
  };

  qtyInputs.change(calculateAndValidateTotal);
  calculateAndValidateTotal();
}

export var moveHelloRetailRecommendations = function() {
  $(window).on('resize', function() {
    const width = $(window).width();
    if (width <= 767) {
      $('#hello-retail').insertAfter('.summary.entry-summary');
    } else {
      $('#hello-retail').insertAfter('.ws-product-container');
    }
  }).trigger('resize');
}
